<template lang="pug">
v-bottom-sheet(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-sheet.pa-4(style="border-radius: 16px 16px 0 0;")
    div.d-flex.align-center
      div(style="width: 28px;")
      v-spacer
      .text-md.font-semibold New count
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-form.mt-6(ref="form")
      div.d-flex.align-center.justify-space-between
        div.text-sm.font-medium.neutral700--text {{ product.name }}
        div(align="right")
          div.text-sm.neutral700--text {{ getStockUnit(product) }}
          div.text-sm.font-semibold.success500--text Current count: {{ product.inventory_qty }}
      div.mt-3
        div.text-xs.neutral700--text.text-center Count
        v-row.mt-2(no-gutters)
          v-col(cols="2")
            v-btn.left-count-btn(outlined block dense height="60" :disabled="newCount <= 0" @click="newCount--")
              v-icon(color="neutral500") mdi-minus
          v-col(cols="8")
            v-text-field.new-count(v-model="newCount" height="60" placeholder="New count" outlined dense hide-details type="number" :rules="rules.not_empty" @input="checkNumber")
          v-col(cols="2")
            v-btn.right-count-btn(outlined block dense height="60" @click="newCount++")
              v-icon(color="neutral500") mdi-plus
    div.d-flex.align-center.mt-6
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark block :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktakeId: {
      required: true
    },
    product: {
      type: Object,
      default: (() => {})
    },
    changedProducts: {
      type: Array,
      default: (() => [])
    },
    prefillCount: {
      default: 0
    }
  },
  data () {
    return {
      isLoading: false,
      newCount: 0,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0|| `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    ...mapActions(['showMessage']),
    setData () {
      this.newCount = this.prefillCount
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let change = this.newCount - this.product.inventory_qty
      let products = [...this.changedProducts]
      products = products.filter(f => f.id !== this.product.id)
      products.push({ id: this.product.id, change: change })
      this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${this.stocktakeId}`, { products: products })
        .then(() => {
          this.$emit('update:changedProducts', products)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
          this.closeDialog()
        })
    },
    checkNumber () {
      if (Number(this.newCount) < 0) {
        this.newCount = this.newCount.replace(/[^0-9.]/g, '')
      }
      this.newCount = Number(this.newCount)
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
  .new-count {
    border-radius: 0;
    text-align-last: center;
    font-size: 20px;
  }
  .left-count-btn {
    border-radius: 10px 0 0 10px;
    border-color: var(--v-neutral400);
    border-right: 0px;
    padding: 0 !important;
  }
  .right-count-btn {
    border-radius: 0 10px 10px 0;
    border-color: var(--v-neutral400);
    border-left: 0px;
    padding: 0 !important;
  }
}
</style>